import routeName from '../constant';
// import aplCatlCode from '@/json/aplCatlCode';
import codeList from '@/json/codeList';

const code = codeList.MULTI_PAY_CHANGE;
// const aplCatl = aplCatlCode.MULTI_PAY_CHANGE;

export const routesMultiPayChange = [
    {
        path: 'pay-own-terms',
        name: routeName.PAY_OWN_TERMS,
        component: () => import('@/views/aplCatlMultiPayChange/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '申請自行繳費說明', leaveAlert: true, code, pageTitle: '申請自行繳費', unableBack: false },
    },
    {
        path: 'pay-own-policy',
        name: routeName.PAY_OWN_POLICY,
        component: () => import('@/views/aplCatlMultiPayChange/selectPolicy/Index.vue'),
        meta: {
            auth: true, metaTitle: '申請自行繳費保單列表', leaveAlert: true, code, pageTitle: '申請自行繳費', unableBack: false
        },
    },
];
